import { render } from "./event_resource.html?vue&type=template&id=1ff92af6&external"
import script from "./event_resource.js?vue&type=script&lang=js&external"
export * from "./event_resource.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__